module.exports = __webpack_public_path__ + "img/modelled.60c96712.png";